import { useTheme } from '../../providers/GigerProvider/useTheme.js';
import { useToggle } from 'react-use';
import { useLayoutEffect, useState } from 'react';
import useMeasure from '../useMeasure/useMeasure.js';

const useTruncateOptions = _ref => {
  let {
    parentContainer,
    htmlOptions,
    optionsContainer,
    optionWithNumberMaxWidth,
    optionSpaceBetween
  } = _ref;
  const theme = useTheme();
  const optionSpaceBetweenSize = optionSpaceBetween || theme.spacing(0.5);
  const optionWithNumberWidth = optionWithNumberMaxWidth || theme.spacing(4);
  const spaceAroundContainer = theme.spacing(2);
  const [ref, {
    width: parentWidth
  }] = useMeasure();
  useLayoutEffect(() => {
    parentContainer && ref(parentContainer);
  }, [ref, parentContainer]);
  const [initialOptions, setInitialOptions] = useState();
  const [optionsToRender, setOptionsToRender] = useState();
  const [optionsToShowAsNumber, setOptionsToShowAsNumber] = useState(0);
  const [rerender, forceRender] = useToggle(false);

  /**
   * First, render options (and reset other states) so we can grab the children's width later
   * This update is "invisible" for the final user
   */
  useLayoutEffect(() => {
    setOptionsToShowAsNumber(0);
    setOptionsToRender(undefined);
    setInitialOptions(htmlOptions);
  }, [htmlOptions]);

  /**
   * We need to force a rerender when change parentWidth
   * so optionsContainerRef update child nodes with complete option List
   */
  useLayoutEffect(() => {
    if ((optionsContainer === null || optionsContainer === void 0 ? void 0 : optionsContainer.childNodes.length) !== (initialOptions === null || initialOptions === void 0 ? void 0 : initialOptions.length)) {
      setOptionsToRender(undefined);
      forceRender();
    }
  }, [parentWidth, forceRender, initialOptions === null || initialOptions === void 0 ? void 0 : initialOptions.length, optionsContainer]);

  /**
   * Here we can get the children's width and see how many we can render
   */
  useLayoutEffect(() => {
    if (!initialOptions || parentWidth <= 0 || !optionsContainer || optionsContainer.childNodes.length === 0) {
      return;
    }
    let remainingContainerSpace = parentWidth - optionWithNumberWidth - spaceAroundContainer;
    const optionIndexToExclude = Array.from(optionsContainer.childNodes).reduce((acc, child, index) => {
      // We cant render this children. We will render it as a number
      // Also we won't render this children if optionIndexToExclude array have an item
      if (remainingContainerSpace - child.clientWidth > 0 && acc.length === 0) {
        // The first child don't have any margin, but we need to take into account other child's margin
        const childWidth = index > 0 ? child.clientWidth + optionSpaceBetweenSize : child.clientWidth;
        remainingContainerSpace = remainingContainerSpace - childWidth;
        return acc;
      }
      acc.push(index);
      return acc;
    }, []);
    const toFinallyRender = initialOptions.filter((_option, index) => !optionIndexToExclude.includes(index));
    setOptionsToRender(toFinallyRender);
    setOptionsToShowAsNumber(optionIndexToExclude.length);
  }, [rerender, optionsContainer, initialOptions, parentWidth, spaceAroundContainer, optionWithNumberWidth, optionSpaceBetween, optionSpaceBetweenSize, forceRender]);
  return {
    optionsToRender,
    optionsToShowAsNumber
  };
};

export { useTruncateOptions };
//# sourceMappingURL=useTruncateOptions.js.map
